import React from "react";

const Error = () => {
  return (
    <div className="alert alert-danger">Hubo un error cargando los datos</div>
  );
};

export default Error;
